import React from 'react';
import PropTypes from 'prop-types';
import File from 'relements/build/esm/input/file';
import './TaskHeader.scss';
import Checkbox from 'relements/build/esm/input/checkbox';
import Icon from 'relements/build/esm/ui/icon';
import Loader from 'relements/build/esm/ui/loader';

export default function TaskHeader({
  title,
  message,
  value,
  sortableHandle,
  expandHandle,
  onChange,
  onDelete,
  onTransfer,
  id,
  disabled,
}) {
  const { active, image_url: imageURL } = value;
  return (
    <div className="business-tasks-list-item-header">
      <Checkbox.Item
        value={active}
        className="business-tasks-list-item-header-checkbox"
        disabled={disabled}
        onChange={(newActive, e) => {
          e.stopPropagation();
          onChange({ ...value, active: newActive });
        }}
      />
      <File
        disabled={disabled}
        onChange={(newImageURL) => {
          onChange({ ...value, image_url: newImageURL });
        }}
        maxFileSize={1}
      >
        {(uploads, renderInput) => {
          const upload = uploads[0] || {};
          const inProgressImage = upload.previewURL;
          const imageProgress = upload.isUploading && upload.uploadedPercent;
          const uploadingClassName = upload.isUploading && 'uploading';
          return (
            <div className="business-tasks-list-item-header-icon">
              {inProgressImage || imageURL ? (
                <img
                  className={`business-tasks-list-item-header-icon-image ${uploadingClassName}`}
                  src={inProgressImage || imageURL}
                />
              ) : (
                <Icon
                  src="task"
                  className={`business-tasks-list-item-header-icon-image grey-icon ${uploadingClassName}`}
                />
              )}
              {renderInput()}
              {imageProgress && imageProgress < 100 ? (
                <div className="business-tasks-list-item-header-icon-loader">
                  <Loader />
                </div>
              ) : null}
            </div>
          );
        }}
      </File>
      <div className="business-tasks-list-item-header-title">
        {title || <span>New Menu Option</span>}
      </div>
      <div className="business-tasks-list-item-header-user-says">{message}</div>
      <div className="business-tasks-list-item-header-ctas">
        <span>{id}</span>
        {disabled ? null : (
          <Icon
            onClick={onTransfer}
            src="transfer"
            className="business-tasks-list-item-header-cta transfer-icon"
          />
        )}
        {sortableHandle}
        {expandHandle}
      </div>
    </div>
  );
}

TaskHeader.propTypes = {
  expandHandle: PropTypes.func,
  message: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onDelete: PropTypes.func,
  onTransfer: PropTypes.func,
  sortableHandle: PropTypes.object,
  title: PropTypes.string.isRequired,
  value: PropTypes.object,
};

TaskHeader.defaultProps = {
  expandHandle: () => {},
  onChange: () => {},
  onDelete: () => {},
  onTransfer: () => {},
  sortableHandle: {},
  value: {},
};
